import { useTranslation } from 'react-i18next';

import type { Settings } from '@hotjar/webapp/features/Forwarding/ForwardToSlack';
import { ForwardToSlack } from '@hotjar/webapp/features/Forwarding/ForwardToSlack';
import type { Site } from '@hotjar/site';
import { hasCommentedFilter } from '@hotjar/global-filters';
import type { QueryFormatFilter } from '@hotjar/global-filters';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import { LimitationsMessage } from './LimitationsMessage';
import { MessageKind } from './limitations-message-type';

const MessageWrapper = styled.div<{ kind: MessageKind }>`
  margin-top: ${({ kind }) => (kind === MessageKind.NONE ? 0 : tokens.spacer.x2)};
`;

interface Props {
  currentSite: Site | undefined;
  settings: Settings | null;
  onChange: (newSettings: Settings) => void;
  segmentFilters: QueryFormatFilter;
  onEnableError: (message: string) => void;
  onEnableSuccess: (message: string) => void;
  onUpsellRequest: (featureName: string) => void;
}

export const Forward = ({
  currentSite,
  settings,
  onChange,
  segmentFilters,
  onEnableError,
  onEnableSuccess,
  onUpsellRequest,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();

  if (settings === null) {
    // TODO: show some loading spinner or something
    return null;
  }

  const limitationsMessageKind = hasCommentedFilter(segmentFilters)
    ? MessageKind.RESTRICTED_WARNING
    : MessageKind.NONE;

  return (
    <>
      <ForwardToSlack
        onChange={onChange}
        settings={settings}
        switchDisabled={limitationsMessageKind === MessageKind.RESTRICTED_WARNING}
        currentSite={currentSite}
        onEnableError={onEnableError}
        onEnableSuccess={onEnableSuccess}
        upsell={onUpsellRequest}
        header={t('common:recordings.segment-edit-create.forward-to-slack.header')}
        subtext={t('common:recordings.segment-edit-create.forward-to-slack.subtext')}
        contextOfUse={ProductType.Analytics}
      />
      <MessageWrapper kind={limitationsMessageKind}>
        <LimitationsMessage kind={limitationsMessageKind} />
      </MessageWrapper>
    </>
  );
};
